import { render, staticRenderFns } from "./OurVision.vue?vue&type=template&id=3683ab60&scoped=true"
import script from "./OurVision.vue?vue&type=script&lang=ts"
export * from "./OurVision.vue?vue&type=script&lang=ts"
import style0 from "./OurVision.vue?vue&type=style&index=0&id=3683ab60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3683ab60",
  null
  
)

export default component.exports